import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import ReportDetail from '@/ui/pages/Reports/detail/ReportDetail';

// HS-961 / HS-1601: one run — parameters, state, downloads and the data preview.
export const Route = createFileRoute('/_dashboard/reports/$id')({
  beforeLoad: requireRoute('/reports/$id'),
  component: ReportDetail,
});
